import React, { useState, useEffect } from "react";
import { countries } from "./countries";
//import { latestBrussels } from "../../data/latestBrussels";
import { latestParis } from "../../data/latestParis";
//import { latestBarcelona } from "../../data/latestBarcelona";
import { latestLondon } from "../../data/latestLondon";
import { latestIxelles } from "../../data/latestIxelles";
import AppLogo from "../../img/icon.png"

import "./styles.css";
import { useInitFbSDK } from "./hooks";
import {
  oneStNoDomi,
  oneStUnDomi,
  oneStYesDomi,
  twoRYesDomi,
  twoRNoDomi,
  oneRUnDomi,
  oneRNoDomi,
  twoRUnDomi,
  oneRYesDomi,
} from "./constants";
import { useDispatch, useSelector } from "react-redux";
import { getImages } from "../../actions/imageActions";
import { getExtraNowImages } from "../../actions/extraNowImageActions";
import { getCitiesPosts } from "../../actions/citiesPostActions";
//import { FaUpload } from "react-icons/fa";

// You can find your Page ID
// in the "About" section of your page on Facebook.
const PAGE_ID = "111738901185838";

function FacebookPost({fileData}) {

  const dispatch = useDispatch();

  // Initializes the Facebook SDK
  const isFbSDKInitialized = useInitFbSDK();

  // App state
  const [fbUserAccessToken, setFbUserAccessToken] = React.useState();
  const [fbPageAccessToken, setFbPageAccessToken] = React.useState();
  const [postText, setPostText] = React.useState();
  const [htagPost, setHtagPost] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [image, setImage] = React.useState({ preview: "", raw: "" });
  const [imageLink, setImageLink] = React.useState();
  const [adLink, setAdLink] = React.useState();
  const [adLinkPost, setAdLinkPost] = React.useState();
  const [selectedCat, setSelectedCat] = React.useState();
  const [selectedCountry, setSelectedCountry] = React.useState(null);

  const [isPublishing, setIsPublishing] = React.useState(false);
  const [isAutoPublishing, setIsAutoPublishing] = React.useState(false);
  const [selectedLatestCities, setSelectedLatestCities] =
    React.useState([]);

  const [index, setIndex] = useState(0);

  const [isCitiesPosts, setIsCitiesPosts] = React.useState(false);
  const [isExtraNowImageData, setIsExtraNowImageData] = React.useState(false);
  const [isLatestLondon, setIsLatestLondon] = React.useState(false);
  const [isLatestParis, setIsLatestParis] = React.useState(false);
  const [isLatestIxelles, setIsLatestIxelles] = React.useState(false);
  const imageData = useSelector((state)=>state.image.images)
  //console.log('imageData',imageData)
  const citiesposts =fileData
 // const price = citiesposts[0]?.Price
 // console.log('price',price)
 //  console.log('citiesposts',citiesposts)
//console.log('AppLogo',AppLogo)
  useEffect(()=>{
    dispatch(getImages())
    dispatch(getExtraNowImages())
    dispatch(getCitiesPosts())
  },[dispatch])

  const extraNowImageData = useSelector((state)=>state.extranowimage.extranowimages)
  //console.log('extranowimages',extraNowImageData)

  // const longUrlBrussels = ` https://spotahome.sjv.io/c/2913702/870243/12133?url=${
  //   Object.values(
  //     citiesposts.filter((item) => Number(item.Price) < 600)[
  //       index % citiesposts.filter((item) => Number(item.Price) < 600).length
  //     ]
  //   )[14]
  // }`;



  useEffect(() => {
    if (isCitiesPosts === true) {
      setSelectedLatestCities(citiesposts);
      setIsExtraNowImageData(false);
      setIsLatestLondon(false);
      setIsLatestParis(false);
      setIsLatestIxelles(false);
    } else if (isLatestIxelles === true) {
      setSelectedLatestCities(latestIxelles);
      setIsCitiesPosts(false);
      setIsExtraNowImageData(false);
      setIsLatestLondon(false);
      setIsLatestParis(false);
    } else if (isLatestLondon === true) {
      setSelectedLatestCities(latestLondon);
      setIsCitiesPosts(false);
      setIsExtraNowImageData(false);
      setIsLatestParis(false);
      setIsLatestIxelles(false);
    } else if (isLatestParis === true) {
      setSelectedLatestCities(latestParis);
      setIsCitiesPosts(false);
      setIsExtraNowImageData(false);
      setIsLatestLondon(false);
      setIsLatestIxelles(false);
    } else if (isExtraNowImageData === true) {
      setSelectedLatestCities(extraNowImageData);
      setIsCitiesPosts(false);
      setIsLatestLondon(false);
      setIsLatestParis(false);
      setIsLatestIxelles(false);
    } else {
      setIsExtraNowImageData(true);
      setIsCitiesPosts(true);
      setIsLatestLondon(true);
      setIsLatestParis(true);
      setIsLatestIxelles(true);
    }
  }, [
    citiesposts,
    extraNowImageData,
    selectedLatestCities,
    isExtraNowImageData,
    isCitiesPosts,
    isLatestIxelles,
    isLatestLondon,
    isLatestParis,
  ]);

  useEffect(() => {
    const tick = () => setIndex((i) => i + 1);

      const id = setInterval(tick, 4000);
    // const autoPostId = setInterval(setIsAutoPublishing(true), 160000);
    // const isPublishingId = setInterval(setIsPublishing(true), 160000);
    // const sendId = setInterval(sendAutoPostToPage, 160000);
    return () => {
         clearInterval(id);
      // clearInterval(sendId);
      // clearInterval(autoPostId);
      // clearInterval(isPublishingId);
    };
  }, []);

  //latest cities


  // if (loading) return <p>Loading</p>;
  // if (error) return <p>Something when wrong</p>;

  const cat = [
    "select a category",
    "adlinkbuilder",
    "#1room_with_domiciliation",
    "#1room_without_domiciliation",
    "#1room_no_comment_on_domiciliation",
    "#studio_with_domiciliation",
    "#studio_without_domiciliation",
    "#studio_no_comment_on_domiciliation",
    "#2rooms_apartment_with_domiciliation",
    "#2rooms_apartment_without_domiciliation",
    "#2rooms_apartment_no_comment_on_domiciliation",
  ];

  const handleSelectCat = (e) => {
    setSelectedCat(e.target.value);
  };
  const handleSelectCountry = (e) => {
    setSelectedCountry(e.target.value);
  };

  React.useEffect(() => {
    if (selectedCat === "#1room_with_domiciliation") {
      setHtagPost(oneRYesDomi);
    } else if (selectedCat === "#1room_no_comment_on_domiciliation") {
      setHtagPost(oneRUnDomi);
    } else if (selectedCat === "#1room_without_domiciliation") {
      setHtagPost(oneRNoDomi);
    } else if (selectedCat === "#studio_with_domiciliation") {
      setHtagPost(oneStYesDomi);
    } else if (
      selectedCat === "#2rooms_apartment_no_comment_on_domiciliation"
    ) {
      setHtagPost(twoRUnDomi);
    } else if (selectedCat === "#2rooms_apartment_without_domiciliation") {
      setHtagPost(twoRNoDomi);
    } else if (selectedCat === "#studio_without_domiciliation") {
      setHtagPost(oneStNoDomi);
    } else if (selectedCat === "#studio_no_comment_on_domiciliation") {
      setHtagPost(oneStUnDomi);
    } else if (selectedCat === "#2rooms_apartment_with_domiciliation") {
      setHtagPost(twoRYesDomi);
    } else if (selectedCat === "adlinkbuilder") {
      setHtagPost(
        `https://spotahome.sjv.io/c/2913702/870243/12133?url=${adLink}`
      );
    } else {
      setHtagPost("");
    }
  }, [selectedCat, adLink]);

  const work = ["fighting", "learning", "qwerty"];

  const footerMessage =
    "📝 *We help you to find 🏠rooms, studios, apartments in major European cities like #paris, #brussels, #london, #berlin,#dublin, #barcelona, #madrid...* \n \n 🔗  👉 https://bit.ly/3dCpMKj \n Use FBMARIUS15 to have 15% discount on reservation fees \n 💬 🇬🇧🇫🇷 ";

  // Logs in a Facebook user
  const logInToFB = React.useCallback(() => {
    window.FB.login((response) => {
      setFbUserAccessToken(response.authResponse.accessToken);
    });
  }, []);

  // Logs out the current Facebook user
  const logOutOfFB = React.useCallback(() => {
    window.FB.logout(() => {
      setFbUserAccessToken(null);
      setFbPageAccessToken(null);
    });
  }, []);

  // Checks if the user is logged in to Facebook
  React.useEffect(() => {
    if (isFbSDKInitialized) {
      window.FB.getLoginStatus((response) => {
        setFbUserAccessToken(response.authResponse?.accessToken);
      });
    }
  }, [isFbSDKInitialized]);

  // Fetches an access token for the page
  React.useEffect(() => {
    if (fbUserAccessToken) {
      window.FB.api(
        `/${PAGE_ID}?fields=access_token&access_token=${fbUserAccessToken}`,
        ({ access_token }) => setFbPageAccessToken(access_token)
      );
    }
  }, [fbUserAccessToken]);
  // Publishes a post on the Facebook page
  const sendPostToPage = React.useCallback(() => {
    
    setIsPublishing(true);

    window.FB.api(
      `/${PAGE_ID}/feed`,
      "POST",
      {
        message: `📢 ${title.toUpperCase()} - ${
          isAutoPublishing === true ? null : htagPost
        } -📍 + ${
          isAutoPublishing === true ? null : selectedCountry
        } \n \n ${postText} \n \n 🔗 👉 ${adLinkPost}  \n \n \n ${footerMessage} \n ${
          isAutoPublishing === true ? null : selectedCat
        }`,
        link: imageLink
          ? ` https://spotahome.sjv.io/c/2913702/870243/12133?url=${
              Object.values(
                selectedLatestCities.filter((item) => Number(item.Price) < 600)[
                  index %
                    selectedLatestCities.filter(
                      (item) => Number(item.Price) < 600
                    ).length
                ]
              )[14]
            }`
          : null,
        access_token: fbPageAccessToken,
      },
      () => {
        setPostText("");
        setTitle("");
        setHtagPost("");
        // setImage("");
        setImageLink("");
        setAdLinkPost("");
        setAdLink("");
        setIsPublishing(false);
      }
    );
    //window.FB.api(`/${PAGE_ID}/canvases`, "POST");
  }, [
    postText,
    fbPageAccessToken,
    adLinkPost,
    htagPost,
    imageLink,
    selectedCat,
    selectedCountry,
    title,
    isAutoPublishing,
    index,
    selectedLatestCities,
  ]);

  // UI with custom styling from ./styles.css`

  // auto published

  const sendCitiesPosts = React.useCallback(() => { 
    window.FB.api(
      `/${PAGE_ID}/feed`,
      "POST",
      {
        message: `📢 ${(citiesposts[index]?.["# Rooms"]===1||citiesposts[index]?.["# Rooms"]===0)?citiesposts[index]?.["# Rooms"]+"ROOM":citiesposts[index]?.["# Rooms"]+"ROOMS"}, ${"PROPERTY TYPE: " + citiesposts[index]?.["Property Type"].toUpperCase()}-AVAILABLE IN #${citiesposts[index]?.Neigbourhood} 
          "FROM " ${citiesposts[index]?.["Available From"]} -📍#${citiesposts[index]?.City} '💶'${citiesposts[index]?.Price}"€" Verified:${citiesposts[index]?.Verified==='yes'?'✅':'☑️'} 

       \n \n 👉 https://spotahome.sjv.io/c/2913702/870243/12133?url=${citiesposts[index]?.Link} 
       \n \n \n \n ${footerMessage} \n ${htagPost}`,
        //url: AppLogo,
        link: imageLink
        ? `https://graph.facebook.com/111738901185838/photos?url=${imageLink}`
        : "https://www.facebook.com/Logement-Rapide-France-Europe-111738901185838/photos/pcb.164562849236776/164562762570118/",
        
        access_token: fbPageAccessToken,
      },
      () => {
        setPostText("");
        setTitle("");
        setHtagPost("");
        // setImage("");
        setImageLink("");
        setAdLinkPost("");
        setAdLink("");
        setIsPublishing(false);
      }
    );
    //window.FB.api(`/${PAGE_ID}/canvases`, "POST");
  }, [fbPageAccessToken, htagPost, index, imageLink,citiesposts,imageData]);

  const sendExtraNowImageData = React.useCallback(() => {
    window.FB.api(
      `/${PAGE_ID}/feed`,
      "POST",
      {
        message: `📢 ${extraNowImageData[index]?.title.toUpperCase()} 
        FROM ${extraNowImageData[index]?.available_from}- ${extraNowImageData[index]?.lastUpDate} -📍#${extraNowImageData[index]?.city} '💶'${extraNowImageData[index]?.price}"€" Verified:${extraNowImageData[index]?.Verified==='CHEKED'?'✅':'☑️'} \n
       Charges: ${JSON.stringify(extraNowImageData[index].chargesData[0])} \n 
       icianr-ref : ${extraNowImageData[index]?.urlCode} \n
       🚃  ${extraNowImageData[index]?.transportData}
       \n address: ${extraNowImageData[index]?.address} \n
       \n \n 👉 ${extraNowImageData[index]?.url} 
       \n \n \n \n ${footerMessage} \n ${htagPost}`,
       place:` ${extraNowImageData[index]?.city}`,
       // link: imageLink
       //? `https://graph.facebook.com/111738901185838/photos?url=${imageLink}`
      //: `${extraNowImageData[index]?.imgUrls[0]}`,
              
        access_token: fbPageAccessToken,
      },
      () => {
        setPostText("");
        setTitle("");
        setHtagPost("");
        // setImage("");
        setImageLink("");
        setAdLinkPost("");
        setAdLink("");
        setIsPublishing(false);
      }
    );
    //window.FB.api(`/${PAGE_ID}/canvases`, "POST");
  }, [fbPageAccessToken, htagPost, index,extraNowImageData]);

  const sendLatestLondon = React.useCallback(() => {
    window.FB.api(
      `/${PAGE_ID}/feed`,
      "POST",
      {
        message: `📢 ${
          "ROOMS: " +
          Object.values(
            latestLondon.filter((item) => Number(item.Price) < 600)[
              index %
                latestLondon.filter((item) => Number(item.Price) < 600).length
            ]
          )[8] +
          "," +
          "  " +
          "PROPERTY TYPE: " +
          Object.values(
            latestLondon.filter((item) => Number(item.Price) < 600)[
              index %
                latestLondon.filter((item) => Number(item.Price) < 600).length
            ]
          )[7].toUpperCase() +
          "," +
          " " +
          "AVAILABLE IN" +
          " " +
          "#" +
          Object.values(
            latestLondon.filter((item) => Number(item.Price) < 600)[
              index %
                latestLondon.filter((item) => Number(item.Price) < 600).length
            ]
          )[5].toUpperCase() +
          " " +
          "FROM " +
          Object.values(
            latestLondon.filter((item) => Number(item.Price) < 600)[
              index %
                latestLondon.filter((item) => Number(item.Price) < 600).length
            ]
          )[11].toUpperCase()
        } - ${htagPost} -📍 #${
          Object.values(
            latestLondon.filter((item) => Number(item.Price) < 600)[
              index %
                latestLondon.filter((item) => Number(item.Price) < 600).length
            ]
          )[4]
        } \n \n ${
          "RENT : " +
          " " +
          Object.values(
            latestLondon.filter((item) => Number(item.Price) < 600)[
              index %
                latestLondon.filter((item) => Number(item.Price) < 600).length
            ]
          )[9] +
          "€" +
          " " +
          "VERIFIED : " +
          " " +
          Object.values(
            latestLondon.filter((item) => Number(item.Price) < 600)[
              index %
                latestLondon.filter((item) => Number(item.Price) < 600).length
            ]
          )[3]
        } \n \n 🔗 👉 
        }  \n \n \n ${footerMessage} \n ${htagPost}`,
        link: imageLink
          ? `https://graph.facebook.com/111738901185838/photos?url=${imageLink}`
          : "https://www.facebook.com/Logement-Rapide-France-Europe-111738901185838/photos/pcb.164562849236776/164562762570118/",
        access_token: fbPageAccessToken,
      },
      () => {
        setPostText("");
        setTitle("");
        setHtagPost("");
        // setImage("");
        setImageLink("");
        setAdLinkPost("");
        setAdLink("");
        setIsPublishing(false);
      }
    );
    //window.FB.api(`/${PAGE_ID}/canvases`, "POST");
  }, [fbPageAccessToken, htagPost, index, imageLink]);

  const sendLatestParis = React.useCallback(() => {
    window.FB.api(
      `/${PAGE_ID}/feed`,
      "POST",
      {
        message: `📢 ${
          "ROOMS: " +
          Object.values(
            latestParis.filter((item) => Number(item.Price) < 600)[
              index %
                latestParis.filter((item) => Number(item.Price) < 600).length
            ]
          )[8] +
          "," +
          "  " +
          "PROPERTY TYPE: " +
          Object.values(
            latestParis.filter((item) => Number(item.Price) < 600)[
              index %
                latestParis.filter((item) => Number(item.Price) < 600).length
            ]
          )[7].toUpperCase() +
          "," +
          " " +
          "AVAILABLE IN" +
          " " +
          "#" +
          Object.values(
            latestParis.filter((item) => Number(item.Price) < 600)[
              index %
                latestParis.filter((item) => Number(item.Price) < 600).length
            ]
          )[5].toUpperCase() +
          " " +
          "FROM " +
          Object.values(
            latestParis.filter((item) => Number(item.Price) < 600)[
              index %
                latestParis.filter((item) => Number(item.Price) < 600).length
            ]
          )[11].toUpperCase()
        } - ${htagPost} -📍 #${
          Object.values(
            latestParis.filter((item) => Number(item.Price) < 600)[
              index %
                latestParis.filter((item) => Number(item.Price) < 600).length
            ]
          )[4]
        } \n \n ${
          "RENT : " +
          " " +
          Object.values(
            latestParis.filter((item) => Number(item.Price) < 600)[
              index %
                latestParis.filter((item) => Number(item.Price) < 600).length
            ]
          )[9] +
          "€" +
          " " +
          "VERIFIED : " +
          " " +
          Object.values(
            latestParis.filter((item) => Number(item.Price) < 600)[
              index %
                latestParis.filter((item) => Number(item.Price) < 600).length
            ]
          )[3]
        } \n \n 🔗 👉 
        }  \n \n \n ${footerMessage} \n ${htagPost}`,
        link: imageLink
          ? `https://graph.facebook.com/111738901185838/photos?url=${imageLink}`
          : "https://www.facebook.com/Logement-Rapide-France-Europe-111738901185838/photos/pcb.164562849236776/164562762570118/",
        access_token: fbPageAccessToken,
      },
      () => {
        setPostText("");
        setTitle("");
        setHtagPost("");
        // setImage("");
        setImageLink("");
        setAdLinkPost("");
        setAdLink("");
        setIsPublishing(false);
      }
    );
    //window.FB.api(`/${PAGE_ID}/canvases`, "POST");
  }, [fbPageAccessToken, htagPost, index, imageLink]);

  const sendLatestIxelles = React.useCallback(() => {
    window.FB.api(
      `/${PAGE_ID}/feed`,
      "POST",
      {
        message: `📢 ${
          "ROOMS: " +
          Object.values(
            latestIxelles.filter((item) => Number(item.Price) < 600)[
              index %
                latestIxelles.filter((item) => Number(item.Price) < 600).length
            ]
          )[8] +
          "," +
          "  " +
          "PROPERTY TYPE: " +
          Object.values(
            latestIxelles.filter((item) => Number(item.Price) < 600)[
              index %
                latestIxelles.filter((item) => Number(item.Price) < 600).length
            ]
          )[7].toUpperCase() +
          "," +
          " " +
          "AVAILABLE IN" +
          " " +
          "#" +
          Object.values(
            latestIxelles.filter((item) => Number(item.Price) < 600)[
              index %
                latestIxelles.filter((item) => Number(item.Price) < 600).length
            ]
          )[5].toUpperCase() +
          " " +
          "FROM " +
          Object.values(
            latestIxelles.filter((item) => Number(item.Price) < 600)[
              index %
                latestIxelles.filter((item) => Number(item.Price) < 600).length
            ]
          )[11].toUpperCase()
        } - ${htagPost} -📍 #${
          Object.values(
            latestIxelles.filter((item) => Number(item.Price) < 600)[
              index %
                latestIxelles.filter((item) => Number(item.Price) < 600).length
            ]
          )[4]
        } \n \n ${
          "RENT : " +
          " " +
          Object.values(
            latestIxelles.filter((item) => Number(item.Price) < 600)[
              index %
                latestIxelles.filter((item) => Number(item.Price) < 600).length
            ]
          )[9] +
          "€" +
          " " +
          "VERIFIED : " +
          " " +
          Object.values(
            latestIxelles.filter((item) => Number(item.Price) < 600)[
              index %
                latestIxelles.filter((item) => Number(item.Price) < 600).length
            ]
          )[3]
        } \n \n 🔗 👉 
        \n \n \n ${footerMessage} \n ${htagPost}`,
        link: imageLink
          ? `https://graph.facebook.com/111738901185838/photos?url=${imageLink}`
          : "https://www.facebook.com/Logement-Rapide-France-Europe-111738901185838/photos/pcb.164562849236776/164562762570118/",
        access_token: fbPageAccessToken,
      },
      () => {
        setPostText("");
        setTitle("");
        setHtagPost("");
        // setImage("");
        setImageLink("");
        setAdLinkPost("");
        setAdLink("");
        setIsPublishing(false);
      }
    );
    //window.FB.api(`/${PAGE_ID}/canvases`, "POST");
  }, [fbPageAccessToken, htagPost, index, imageLink]);

  return (
    <div id="app">
      <header id="app-header">
        <h1 id="logo-text">
          Publiez sur la Page FB Logement Rapide France Europe
        </h1>
        {fbUserAccessToken ? (
          <button onClick={logOutOfFB} className="btn confirm-btn">
            Log out
          </button>
        ) : (
          <button onClick={logInToFB} className="btn confirm-btn">
            Login with Facebook
          </button>
        )}
      </header>
      <main id="app-main">
        {fbPageAccessToken ? (
          <>
            <h3 className="titre">
              Postez une annonce sur Logement Rapide france Europe
            </h3>
            {!isAutoPublishing && (
              <div className="fb-post-container">
                <div className="section">
                  <div className="fb-post-item">
                    <label>Catégories: </label>
                    <select
                      value={selectedCat}
                      onChange={(e) => handleSelectCat(e)}
                      label="Catégories"
                    >
                      {cat.map((_, i) => (
                        <option key={i} value={cat[i]}>
                          {cat[i]}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="fb-post-item">
                    <label>Pays: </label>

                    <select
                      value={isAutoPublishing === true ? null : selectedCountry}
                      onChange={(e) => handleSelectCountry(e)}
                      label="Pays"
                    >
                      {countries.map((_, i) => (
                        <option key={i} value={`#${countries[i]}`}>
                          #{countries[i]}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="fb-post-item">
                    <textarea
                      value={isAutoPublishing === true ? null : htagPost}
                      onChange={(e) => setHtagPost(e.target.value)}
                      placeholder={htagPost}
                      cols={40}
                      rows="3"
                    />
                  </div>
                </div>
                <div className="section">
                  <div className="fb-post-item">
                    <input
                      value={title}
                      placeholder="Titre..."
                      onChange={(e) => setTitle(e.target.value)}
                      disabled={isPublishing}
                    />
                  </div>
                  <div className="fb-post-item">
                    <textarea
                      value={postText}
                      onChange={(e) => setPostText(e.target.value)}
                      placeholder="Message..."
                      rows="8"
                      disabled={isPublishing}
                    />
                  </div>

                  <div className="fb-post-item">
                    <input
                      value={adLink}
                      placeholder="créez un lien"
                      onChange={(e) => setAdLink(e.target.value)}
                      disabled={isPublishing}
                    />
                  </div>

                  <div>
                    <input
                      value={adLinkPost}
                      placeholder="Attachez un lien au post"
                      onChange={(e) => setAdLinkPost(e.target.value)}
                      disabled={isPublishing}
                    />
                  </div>

                  <div className="fb-post-item">
                    <input
                      value={imageLink}
                      placeholder="Attachez une image à ce post"
                      onChange={(e) => setImageLink(e.target.value)}
                      disabled={isPublishing}
                    />
                  </div>
                

                  <div className="fb-post-item">
                    <button
                      onClick={sendPostToPage}
                      className="btn confirm-btn"
                      disabled={!postText || isPublishing}
                    >
                      {isPublishing ? "Publishing..." : "Publish"}
                    </button>
                    <button
                      className="btn"
                      onClick={() => {
                        setIsAutoPublishing(!isAutoPublishing);
                      }}
                    >
                      Switch to Auto
                    </button>
                  </div>
                </div>
              </div>
            )}
            {isAutoPublishing && (
              <div className="fb-post-container">
                <div className="section">
                  <div className="fb-post-item">
                    <label>Catégories: </label>
                    <select
                      value={selectedCat}
                      onChange={(e) => handleSelectCat(e)}
                      label="Catégories"
                    >
                      {cat.map((_, i) => (
                        <option key={i} value={cat[i]}>
                          {cat[i]}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="fb-post-item">
                    <label>Pays: </label>

                    <select
                      value={selectedCountry}
                      onChange={(e) => handleSelectCountry(e)}
                      label="Pays"
                    >
                      {countries.map((_, i) => (
                        <option key={i} value={`#${countries[i]}`}>
                          #{countries[i]}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="fb-post-item">
                    <textarea
                      value={htagPost}
                      onChange={(e) => setHtagPost(e.target.value)}
                      placeholder={htagPost}
                      cols={40}
                      rows="3"
                    />
                    {/* {work[index % work.length]} */}
                  </div>
                </div>
                <div className="section">
                  <div className="fb-post-item">
                    <input
                      value={title}
                      placeholder="Titre..."
                      onChange={(e) => setTitle(e.target.value)}
                      disabled={isPublishing}
                    />
                  </div>
                  <div className="fb-post-item">
                    <textarea
                      value={postText}
                      onChange={(e) => setPostText(e.target.value)}
                      placeholder="Message..."
                      rows="8"
                      disabled={isPublishing}
                    />
                  </div>

                  <div className="fb-post-item">
                    <input
                      value={adLink}
                      placeholder="créez un lien"
                      onChange={(e) => setAdLink(e.target.value)}
                      disabled={isPublishing}
                    />
                  </div>

                  <div>
                    <input
                      value={adLinkPost}
                      placeholder="Attachez un lien au post"
                      onChange={(e) => setAdLinkPost(e.target.value)}
                      disabled={isPublishing}
                    />
                  </div>

                  <div className="fb-post-item">
                    <input
                      value={imageLink}
                      placeholder="Attachez une image à ce post"
                      onChange={(e) => setImageLink(imageLink?e.target.value:AppLogo)}
                      disabled={isPublishing}
                    />
                  </div>
                  <div>
                    {/* <label htmlFor="upload-button">
                    {image.preview ? (
                      <img
                        src={image.preview}
                        alt="dummy"
                        width="100"
                        height="100"
                      />
                    ) : (
                      <>
                        <span className="fa-stack fa-2x mt-3 mb-2">
                          <FaUpload color="light-gray" />
                        </span>
                      </>
                    )}
                  </label> */}
                    {/* <input
                    type="file"
                    id="upload-button"
                    style={{ display: "none" }}
                    onChange={handleChange}
                  /> */}

                    {/* <button style={{ margin: "10px" }} onClick={handleUpload}>
                    Upload
                  </button> */}
                  </div>
                  <div className="fb-post-item">
                    <label>Switch Cities: </label>
                    <button
                      className="btn"
                      onClick={() => {
                        setIsCitiesPosts(!isCitiesPosts);
                        sendCitiesPosts();
                      }}
                    >
                      CitiesPosts {isCitiesPosts === false ? "🔴" : "🟢"}
                    </button>
                    <button
                      className="btn"
                      onClick={() => {
                        setIsExtraNowImageData(!isExtraNowImageData);
                        sendExtraNowImageData();
                      }}
                    >
                      ExtraNow {isExtraNowImageData === false ? "🔴" : "🟢"}
                    </button>
                    <button
                      className="btn"
                      onClick={() => {
                        setIsLatestLondon(!isLatestLondon);
                        sendLatestLondon();
                      }}
                    >
                      LatestLondon{isLatestLondon === false ? "🔴" : "🟢"}
                    </button>
                    <button
                      className="btn"
                      onClick={() => {
                        setIsLatestParis(!isLatestParis);
                        sendLatestParis();
                      }}
                    >
                      LatestParis {isLatestParis === false ? "🔴" : "🟢"}
                    </button>
                    <button
                      className="btn"
                      onClick={() => {
                        setIsLatestIxelles(!isLatestIxelles);
                        sendLatestIxelles();
                      }}
                    >
                      LatestIxelles {isLatestIxelles === false ? "🔴" : "🟢"}
                    </button>
                  </div>
                  <div className="fb-post-item">
                    <button
                      className="btn"
                      onClick={() => {
                        setIsAutoPublishing(!isAutoPublishing);
                      }}
                    >
                      Switch to Normal
                    </button>
                    <button
                      // onClick={sendAutoPostToPage}
                      className="btn confirm-btn"
                      // disabled={!postText || isPublishing}
                    >
                      {isAutoPublishing ? "Publishing..." : "Publish"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <h2 className="placeholder-container">Welcome!</h2>
        )}
      </main>
    </div>
  );
}

export default FacebookPost;
